import React,{useEffect,useState} from 'react';
import ProductDefaultImage from '../../../assets/images/product-default-image.jpg'
import { LazyLoadImage } from 'react-lazy-load-image-component';

const SuggestionCard = ({ data, onSelectProduct, onAddToCart, noOutOfStock, isDeliveryAddressSet, checkAvailiblityAlert, isOutside}) => {
  const [dynamicProductPrice, setProductPrice] = useState("");
    useEffect(() => {
        getPriceOfProduct(isOutside);
      
      }, []);
    useEffect(() => {
        getPriceOfProduct(isOutside);
      
      }, [isOutside]);
      const getPriceOfProduct=(isOutside)=>{
        // console.log("getPriceOfProduct(isOutside)",isOutside);
            
            if(isOutside){
              let outsideBoundaryPrice=data && data.Suggested ? data.Suggested.toFixed(2) : '';
              setProductPrice(outsideBoundaryPrice)
            }else{
        
              let insideBoundaryPrice=data && data.PriceB ? data.PriceB.toFixed(2) : ''
              setProductPrice(insideBoundaryPrice)
            }
          }
    const productTitle = data && data.Description ? data.Description : '';
    const productImage = data && data.image ? data.image : null;
    const urlImage = productImage ? productImage.replace(/upload/, 'upload/w_250,h_280,c_fill')
        : null;
    const productPrice = dynamicProductPrice;
    const productSize = data && data.Size ? data.Size : '';
    const isOutOfStock = !(data && data.Qty > 0);
    const isOnSale = data.OnSale ? true : false
    const salePrice = data.SalePrice
    return (
        <div className="suggestion-card">
            <div className="image-container" onClick={onSelectProduct ? onSelectProduct : null}>
                <div className="wrapper">
                    <LazyLoadImage src={urlImage ? urlImage : ProductDefaultImage} onError={(e) => {
                        return e.target.src = ProductDefaultImage
                    }} />
                </div>
            </div>
            <div className={`info-container ${onAddToCart ? 'has-cart-button' : ''}`}>
                <div className="title" onClick={onSelectProduct ? onSelectProduct : null}>{productTitle}</div>
                <div className="subtitle">{productSize}</div>
                {isDeliveryAddressSet?(isOnSale ?
                    <div className="sale-price-container">
                        <div className="row">
                            <div className="col-5">
                                <span className="sale-label">WAS</span>
                            </div>
                            <div className="col-5">
                                <span className="sale-label">NOW</span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-5">
                                <div className="sale-original-price-text" onClick={onSelectProduct ? onSelectProduct : null}><s>{productPrice ? `$${productPrice}` : ''}</s></div>
                            </div>
                            <div className="col-5">
                                <div className="sale-price-text" onClick={onSelectProduct ? onSelectProduct : null}>{salePrice ? `$${salePrice}` : ''}</div>
                            </div>

                        </div>
                    </div>
                    :
                    <div className="price-text" onClick={onSelectProduct ? onSelectProduct : null}>{productPrice ? `$${productPrice}` : ''}</div>
                ):null}
                {isDeliveryAddressSet?(onAddToCart ? (
                    <div className="add-to-cart-button" onClick={onAddToCart}>Add to Cart</div>
                ) : null):(<div className="add-to-cart-button" onClick={checkAvailiblityAlert}>Check Availbilty</div>)}
            </div>
            {isOutOfStock && !noOutOfStock ? (
                <div className="outofstock-tag">Out of Stock</div>
            ) : null}
        </div>
    )
}

export default SuggestionCard;



// WEBPACK FOOTER //
// ./src/components/commons/cards/SuggestionCard.js